/** The main panel for a study: its latest Result once there is one, the hero until then. */

import { Navigate, useParams } from "react-router";

import { Hero } from "@/app/Hero";
import { useRuns } from "@/lib/queries";

export function StudyHome() {
  const { studyId } = useParams();
  const runs = useRuns(studyId).data;
  const latest = runs?.filter((r) => r.status === "done").at(-1);
  if (studyId && latest) return <Navigate to={`/studies/${studyId}/runs/${latest.run_id}`} replace />;
  return <Hero />;
}

export function StudyRedirect() {
  const { studyId } = useParams();
  return <Navigate to={studyId ? `/studies/${studyId}` : "/"} replace />;
}
